// @flow

import {Tag} from 'docs/util';
import type {MarkdocTagRegistration} from 'docs/markdoc';
import {getPropInfo} from './getPropInfo';

export const TailorPropsTable: MarkdocTagRegistration = {
  tag: 'tailor-props-table',
  component: 'TailorPropsTable',
  selfClosing: true,
  attributes: {
    component: {
      type: String,
      description: 'Tailor UI Toolkit component',
      required: true,
    },
  },
  render(node, config) {
    const component = node.attributes.component;
    return new Tag(this.tag, {
      component: node.attributes.component,
      propInfo: getPropInfo(component),
    });
  },
  validate(node) {
    const component = node.attributes.component;
    const propInfo = getPropInfo(component);

    if (!propInfo) {
      return [
        {
          id: 'tailor-props-table-invalid-component',
          // TODO - make this a critical error
          level: 'warning',
          message: 'The component is missing prop table data',
        },
      ];
    }

    return [];
  },
};
